import { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { CommonService } from "../js_modules/CommonService";
import $ from "jquery";

import { SellToWebAdminInputComponent } from "../common/selltowebinput/SellToWebAdminInputComponent";
import { SellToWebAdminDropdownComponent } from "../common/selltowebdropdown/SellToWebAdminDropdownComponent";
import { SellToWebModalConfirmationComponent } from "../common/selltowebmodalconfirmation/SellToWebModalConfirmationComponent";
import { SellToWebTableComponent } from "../common/selltowebtable/SellToWebTableComponent";
import { SellToWebTableRowComponent } from "../common/selltowebtable/SellToWebTableRowComponent";
import { SellToWebTableColumnComponent } from "../common/selltowebtable/SellToWebTableColumnComponent";
import { SellToWebInputFileComponent } from "../common/selltowebinputfilecomponent/SellToWebInputFileComponent";
import { SellToWebSpinnerComponent } from "../common/selltowebspinner/SellToWebSpinnerComponent";
import { SellToWebAdminPageComponent } from "../common/selltowebpage/SellToWebAdminPageComponent";
import { SellToWebAdminModalDialogComponent } from "../common/selltowebmodaldialog/SellToWebAdminModalDialogComponent";
import { SellToWebModalDialogHeaderButtonComponent } from "../common/selltowebmodaldialog/SellToWebModalDialogHeaderButtonComponent";

import { TenantQueryComponent } from "./TenantQueryComponent";

export class TenantRouteComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tenants: null,
            isLoadingData: false,
            selectedTenant: null,
            tenantName: null,
            status: null,
            deleteArtifact: null,
            siteArtifacts: [],
            paintTable: false,
            tenantShortName: null,
            sites: null,
            users: null,
            locations: null,
            locationPaintTable: false,
            selectedLocation: null,
            showAddLocationPopup: false,
            deleteLocation: null,
            name: "",
            address1: "",
            address2: "",
            city: "",
            selectedState: null,
            zip: ""
        };

        this.onGetClick = this.onGetClick.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.onStateChange = this.onStateChange.bind(this);
        this.onDeleteArtifactClick = this.onDeleteArtifactClick.bind(this);
        this.onConfirmationOkClick = this.onConfirmationOkClick.bind(this);
        this.onConfirmationCancelClick = this.onConfirmationCancelClick.bind(this);
        this.onActionColumnCallback = this.onActionColumnCallback.bind(this);
        this.onShowConfirmationClick = this.onShowConfirmationClick.bind(this);
        this.onFileUpload = this.onFileUpload.bind(this);
        this.onLocationActionColumnCallback = this.onLocationActionColumnCallback.bind(this);
        this.onSaveLocationClick = this.onSaveLocationClick.bind(this);
        this.onDeleteLocationClick = this.onDeleteLocationClick.bind(this);
        this.onLocationConfirmationCancelClick = this.onLocationConfirmationCancelClick.bind(this);
        this.onShowLocationConfirmationClick = this.onShowLocationConfirmationClick.bind(this);
        this.onAddLocationClick = this.onAddLocationClick.bind(this);
        this.onEditLocationClick = this.onEditLocationClick.bind(this);
        this.onCancelAddLocation = this.onCancelAddLocation.bind(this);

        props.onPageChanged({
            pageTitle: this.pageTitle
        });
    }

    pageTitle = "Tenant";

    states = ["AL", "AK", "AR", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT", "NC", "NE", "NH", "NJ", "NM", "NV", "NY", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WI", "WV", "WY"]

    componentDidMount() {
        try {
            this.props.applicationInsights.trackPageView({ name: this.pageTitle, url: "/Tenant/Tenant", pageType: "Consumer/Admin", isLoggedIn: "Yes", properties: { logon: this.props.logon } });
            CommonService.clientAzureStorageLog("TenantRouteComponent", "componentDidMount", null, null, null, null, this.props.applicationInsights);
            this.getTenants();
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "componentDidMount");
        }
    }

    getTenants() {
        try {
            this.setState({ isLoadingData: true });
            this.props.applicationInsights.trackTrace({ message: "TenantRouteComponent/getTenants", properties: { logon: this.props.logon } });
            fetch("/Tenant/GetTenants", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        isLoadingData: false,
                        tenants: parsedResponse.result
                    });
                })
                .catch(notOKResponse => {
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/Tenant/GetTenants", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "TenantRouteComponent", "getTenants");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "TenantRouteComponent", "getTenants");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "getTenants");
        }
    }

    getSites() {
        this.setState({ isLoadingData: true });

        let inputData = {
            tenantGuid: this.state.selectedTenant?.guid,
        };
        this.props.applicationInsights.trackTrace({ message: "TenantRouteComponent/getSites", properties: { ...inputData, logon: this.props.logon } });
        fetch("/Tenant/GetSites", {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8;"
            },
            body: JSON.stringify(inputData),
            credentials: "same-origin"
        })
            .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
            .then(parsedResponse => {
                this.setState({
                    sites: parsedResponse,
                    //selectedSite: selectedSite,
                    isLoadingData: false,
                });
            })
            .catch(notOKResponse => {
                this.setState({
                    isLoadingData: false
                });
                if (notOKResponse.status === 500) {
                    notOKResponse.json()
                        .then(parsedError => {
                            this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/Tenant/GetSites", ...inputData, ...parsedError, logon: this.props.logon } });
                            console.logError(parsedError, "TenantRouteComponent", "getSites");
                            this.props.onShowAlert("danger", parsedError);
                        })
                        .catch(jsonParseError => {
                            console.logError(jsonParseError, "TenantRouteComponent", "getSites");
                        });
                }
            });
    }

    getTenantUsers() {
        try {
            let inputData = {
                tenantGuid: this.state.selectedTenant?.guid
            };
            this.props.applicationInsights.trackTrace({ message: "TenantRouteComponent/getTenantUsers", properties: { ...inputData, logon: this.props.logon } });
            fetch("/Tenant/GetUsers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json() } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        paintTable: true,
                        users: parsedResponse.table
                    }, this.setState({ paintTable: false }));
                })
                .catch(notOKResponse => {
                    this.setState({
                        paintTable: true
                    }, this.setState({ paintTable: false }));
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/Tenant/GetUsers", ...inputData, ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "TenantRouteComponent", "getTenantUsers");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "TenantRouteComponent", "getTenantUsers");
                            });
                    }
                });
        } catch (error) {
            console.logError(error, "TenantRouteComponent", "getTenantUsers");
        }
    }

    getLocations() {
        try {
            let inputData = {
                tenantGuid: this.state.selectedTenant?.guid
            }
            this.props.applicationInsights.trackTrace({ message: "TenantRouteComponent/getLocations", properties: { ...inputData, logon: this.props.logon } });
            fetch("/Tenant/GetTenantLocation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    parsedResponse.table.forEach((rowData) => {
                        rowData.address = (rowData.address1 ? rowData.address1 + " " : "") +
                            (rowData.address2 ? rowData.address2 + " " : "") +
                            (rowData.city ? rowData.city + " " : "") +
                            (rowData.state ? rowData.state + " " : "") +
                            rowData.zip;

                        rowData.addressLink = "https://www.google.com/maps/place/" + rowData.address.replaceAll(' ', '+');
                    });
                    this.setState({
                        locations: parsedResponse.table,
                        locationPaintTable: true
                    }, () => {
                        this.setState({ locationPaintTable: false });
                    });
                })
                .catch(notOKResponse => {
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/Tenant/GetTenantLocation", ...inputData, ...parsedError, logon: this.props.logon } });
                                console.logError(notOKResponse, parsedError);
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError);
                            });
                    }
                })
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "getLocations");
        }
    }

    getArtifacts() {
        try {
            let inputData = {
                tenantGuid: this.state.selectedTenant?.guid,
                tenantShortName: this.state.tenantShortName
            };
            this.props.applicationInsights.trackTrace({ message: "TenantRouteComponent/getArtifacts", properties: { ...inputData, logon: this.props.logon } });
            fetch("/Tenant/GetSiteArtifacts", {
                method: "POST",
                headers: {
                    'Content-Type': "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        siteArtifacts: parsedResponse,
                        paintTable: true
                    }, () => {
                        this.setState({ paintTable: false });
                    });
                })
                .catch(notOKResponse => {
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/Tenant/GetSiteArtifacts", ...inputData, ...parsedError, logon: this.props.logon } });
                                console.logError(notOKResponse, parsedError);
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError);
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "getArtifacts");
        }
    }

    onTextChange(id, value) {
        try {
            this.setState({ [id]: value });
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "onTextChange", id);
        }
    }

    onStateChange(id, value) {
        try {
            this.setState({ [id]: value });
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "onStateChange", id);
        }
    }

    onGetClick(selectedTenant) {
        try {
            this.setState({
                selectedTenant: selectedTenant,
                tenantName: selectedTenant?.name,
                tenantShortName: selectedTenant?.shortName,
                status: selectedTenant?.status
            }, () => {
                this.getSites();
                this.getTenantUsers();
                this.getLocations();
                this.getArtifacts();
            });
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "onGetClick");
        }
    }

    onDeleteArtifactClick(event, artifactToDelete) {
        let inputData = {
            tenantGuid: this.state.selectedTenant?.guid,
            tenantShortName: this.state.tenantShortName,
            fileName: artifactToDelete.name
        };
        try {
            this.props.applicationInsights.trackTrace({ message: "TenantRouteComponent/onDeleteArtifactClick", properties: { ...inputData, logon: this.props.logon } });
            fetch("/Tenant/DeleteArtifact", {
                method: "POST",
                headers: {
                    'Content-Type': "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        deleteArtifact: null
                    });
                })
                .catch(notOKResponse => {
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/Tenant/DeleteArtifact", ...inputData, ...parsedError, logon: this.props.logon } });
                                this.setState({
                                    deleteArtifact: null
                                });
                                console.logError(notOKResponse, parsedError);
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError);
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "onDeleteArtifactClick");
        }
    }

    onConfirmationOkClick(event) {
        try {
            this.onDeleteArtifactClick(event, this.state.deleteArtifact);
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "onConfirmationOkClick");
        }
    }

    onConfirmationCancelClick(event, rowData) {
        try {
            this.setState({ deleteArtifact: null });
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "onConfirmationCancelClick");
        }
    }

    onShowConfirmationClick(event, rowData) {
        try {
            this.setState({ deleteArtifact: rowData });
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "onShowConfirmationClick");
        }
    }

    onActionColumnCallback(rowData) {
        return rowData.name === undefined
            ? <Fragment>
                <button type="button" className="btn btn-link admin-tenant-site-detail-delete" onClick={(event) => this.onDeleteArtifactClick(event, rowData)}>
                    <span className="fas fa-window-close text-danger app-fs-18 admin-icon" aria-hidden={true} />
                </button>
            </Fragment>
            : <button type="button" className="btn btn-link admin-tenant-site-detail-delete" onClick={(event) => this.onShowConfirmationClick(event, rowData)}>
                <span className="fas fa-window-close text-danger app-fs-18 admin-icon" aria-hidden={true} />
            </button>;
    }

    onFileUpload(event) {
        try {
            let fileUpload = $('#siteArtifactFile')[0];

            var formData = new FormData();
            formData.append("FileUpload", fileUpload.files[0]);
            formData.append("TenantGuid", this.state.selectedTenant?.guid);
            formData.append("TenantShortName", this.state.tenantShortName);

            this.setState({ isLoadingData: true });

            try {
                this.props.applicationInsights.trackTrace({ message: "TenantRouteComponent/onFileUpload", properties: { ...formData, logon: this.props.logon } });
                fetch("/Tenant/UploadArtifact", {
                    method: "POST",
                    headers: {
                        'enctype': "multipart/form-data"
                    },
                    body: formData,
                    credentials: "same-origin"
                })
                    .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                    .then(parsedResponse => {
                        this.setState({ isLoadingData: false });
                        this.getArtifacts();
                        this.props.onShowAlert("success", { message: "Artifact uploaded successfully!" }, 4000);
                    })
                    .catch(notOKResponse => {
                        if (notOKResponse.status === 500) {
                            notOKResponse.json()
                                .then(parsedError => {
                                    this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/Tenant/UploadArtifact", ...formData, ...parsedError, logon: this.props.logon } });
                                    console.logError(notOKResponse, parsedError);
                                    this.props.onShowAlert("danger", parsedError);
                                })
                                .catch(jsonParseError => {
                                    console.logError(jsonParseError);
                                });
                        }
                    })
            } catch (error) {
                console.logError(error, "TenantRouteComponent", "onFileUpload");
            }
        }
        catch (error) {
            console.logError(error);
        }
    }

    onSaveLocationClick() {
        let inputData = {
            id: this.state.selectedLocation?.id,
            tenantGuid: this.state.selectedTenant?.guid,
            name: this.state.name ?? "",
            address1: this.state.address1 ?? "",
            address2: this.state.address2 ?? "",
            city: this.state.city ?? "",
            state: this.state.selectedState ?? "",
            zip: this.state.zip ?? ""
        }
        try {
            this.props.applicationInsights.trackTrace({ message: "TenantRouteComponent/onSaveLocationClick", properties: { ...inputData, logon: this.props.logon } });
            fetch("/Tenant/SaveTenantLocation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        showAddLocationPopup: false,
                        selectedLocation: null
                    }, () => {
                        this.getLocations();
                    });
                })
                .catch(notOKResponse => {
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/Tenant/SaveTenantLocation", ...inputData, ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "TenantRouteComponent", "onSaveLocationClick");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError);
                            });
                    }
                })
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "onSaveLocationClick");
        }
    }

    onAddLocationClick(event) {
        this.setState({
            showAddLocationPopup: true,
            selectedLocation: null,
            name: "",
            address1: "",
            address2: "",
            city: "",
            selectedState: null,
            zip: ""
        });
    }

    onEditLocationClick(event, rowData) {
        this.setState({
            showAddLocationPopup: true,
            selectedLocation: rowData,
            name: rowData.name ?? "",
            address1: rowData.address1 ?? "",
            address2: rowData.address2 ?? "",
            city: rowData.city ?? "",
            selectedState: rowData.state,
            zip: rowData.zip ?? ""
        });
    }

    onCancelAddLocation(event) {
        try {
            this.setState({ showAddLocationPopup: false });
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "onCancelAddLocation");
        }
    }

    onDeleteLocationClick(event) {
        let inputData = {
            id: this.state.deleteLocation.id,
            tenantGuid: this.state.deleteLocation.tenantGuid
        };
        try {
            this.props.applicationInsights.trackTrace({ message: "TenantRouteComponent/onDeleteLocationClick", properties: { ...inputData, logon: this.props.logon } });
            fetch("/Tenant/DeleteTenantLocation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({ deleteLocation: null });
                    this.getLocations();
                })
                .catch(notOKResponse => {
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/Tenant/DeleteTenantLocation", ...inputData, ...parsedError, logon: this.props.logon } });
                                console.logError(notOKResponse, parsedError);
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError);
                            });
                    }
                })
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "onDeleteLocationClick");
        }
    }

    onLocationConfirmationCancelClick(event, rowData) {
        try {
            this.setState({ deleteLocation: null });
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "onLocationConfirmationCancelClick");
        }
    }

    onShowLocationConfirmationClick(event, rowData) {
        try {
            this.setState({ deleteLocation: rowData });
        }
        catch (error) {
            console.logError(error, "TenantRouteComponent", "onShowLocationConfirmationClick");
        }
    }

    onLocationActionColumnCallback(rowData) {
        return <Fragment>
            <button type="button" className="btn btn-link admin-tenant-site-detail-delete" onClick={(event) => this.onEditLocationClick(event, rowData)}>
                <span className="fas fa-edit app-fs-18" aria-hidden={true} />
            </button>
            <button type="button" className="btn btn-link admin-tenant-site-detail-delete" onClick={(event) => this.onShowLocationConfirmationClick(event, rowData)}>
                <span className="fas fa-window-close text-danger app-fs-18 admin-icon" aria-hidden={true} />
            </button>
        </Fragment>;
    }

    render() {
        let sites = [];
        if (this.state.sites) {
            this.state.sites.forEach((site, index) => {
                sites.push(
                    <Fragment>
                        <Link target="_blank" to={"/tenant/site/" + site.tenantGuid + "/" + site.guid}>{site.siteName}</Link>
                        <br />
                    </Fragment>
                );
            });
        }

        return <SellToWebAdminPageComponent>
            <div className="d-flex flex-column admin-fill-content admin-body">
                <SellToWebAdminModalDialogComponent
                    title={this.state.selectedLocation ? "Edit Location" : "Add Location"}
                    showDialog={this.state.showAddLocationPopup}
                    className="admin-tenant-add-location-dialog"
                    onCancelClick={this.onCancelAddLocation}
                >
                    <SellToWebModalDialogHeaderButtonComponent>
                        <button className="btn btn-primary" disabled={!this.state.name || !this.state.address1 || !this.state.city || !this.state.selectedState || !this.state.zip} onClick={(event) => this.onSaveLocationClick(event)}>
                            Save
                        </button>
                    </SellToWebModalDialogHeaderButtonComponent>
                    <div className="admin-body">
                        <div className="card">
                            <div className="card-body">
                                <SellToWebAdminInputComponent id="name" label="Name" value={this.state.name} onChange={this.onTextChange} colSpan="col-12" labelSpan="col-2" controlSpan="col-10" isRequired />
                                <SellToWebAdminInputComponent id="address1" label="Address1" value={this.state.address1} onChange={this.onTextChange} colSpan="col-12" labelSpan="col-2" controlSpan="col-10" isRequired />
                                <SellToWebAdminInputComponent id="address2" label="Address2" value={this.state.address2} onChange={this.onTextChange} colSpan="col-12" labelSpan="col-2" controlSpan="col-10" />
                                <SellToWebAdminInputComponent id="city" label="City" value={this.state.city} onChange={this.onTextChange} colSpan="col-12" labelSpan="col-2" controlSpan="col-10" isRequired />
                                <SellToWebAdminDropdownComponent id="selectedState" label="State" data={this.states} value={this.state.selectedState ?? "Select State"} colSpan="col-12" labelSpan="col-2" controlSpan="col-10" onItemClick={this.onStateChange} isRequired />
                                <SellToWebAdminInputComponent id="zip" label="Zip" value={this.state.zip} onChange={this.onTextChange} colSpan="col-12" labelSpan="col-2" controlSpan="col-10" isRequired />
                            </div>
                        </div>
                    </div>
                </SellToWebAdminModalDialogComponent>
                <SellToWebModalConfirmationComponent
                    headerText={"Delete Location: " + (this.state.deleteLocation !== null ? this.state.deleteLocation.name : "")}
                    bodyText={"Are you sure you want to delete " + (this.state.deleteLocation !== null ? this.state.deleteLocation.name : "") + "?"}
                    showConfirmation={this.state.deleteLocation !== null}
                    onOkClick={this.onDeleteLocationClick}
                    onCancelClick={this.onLocationConfirmationCancelClick}
                    className="admin-global-user-edit-modal" />
                <SellToWebModalConfirmationComponent
                    headerText={"Delete Artifact: " + (this.state.deleteArtifact !== null ? this.state.deleteArtifact.name : "")}
                    bodyText={"Are you sure you want to delete " + (this.state.deleteArtifact !== null ? this.state.deleteArtifact.name : "") + "?"}
                    showConfirmation={this.state.deleteArtifact !== null}
                    onOkClick={this.onConfirmationOkClick}
                    onCancelClick={this.onConfirmationCancelClick}
                    className="admin-global-user-edit-modal" />
                <TenantQueryComponent
                    tenants={this.state.tenants}
                    onGetClick={this.onGetClick}
                    isLoadingData={this.state.isLoadingData}
                    isGlobalAdmin={this.props.isGlobalAdmin}
                    onShowAlert={this.props.onShowAlert}
                    applicationInsights={this.props.applicationInsights}
                    logon={this.state.logon}
                />
                <br />
                <div className="admin-flex-item">
                    <div className="d-flex flex-row">
                        <div style={{ "minWidth": "50%", "marginRight": "10px" }}>
                            <div className="card">
                                <div className="card-header">
                                    {this.state.selectedTenant?.name}
                                </div>
                                <div className="card-block">
                                    <SellToWebAdminInputComponent id="tenantName" label="Tenant Name" value={this.state.tenantName} onChange={this.onTextChange} disabled colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                                    <SellToWebAdminInputComponent disabled id="tenantShortName" label="Tenant Short Name" value={this.state.tenantShortName} onChange={this.onTextChange} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                                    <SellToWebAdminInputComponent disabled id="status" label="Status" value={this.state.status} onChange={this.onTextChange} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                                    <div className="admin-control row">
                                        <div className="col-4" style={{ "padding": "0px" }}>Tenant Sites:</div>
                                        <div className="col-8" style={{ "padding": "0px" }}>{sites}</div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="card">
                                <div className="card-header">
                                    Tenant Users
                                </div>
                                <div className="card-block">
                                    <SellToWebTableComponent tableData={this.state.users} paintTable={this.state.paintTable}>
                                        <SellToWebTableRowComponent>
                                            <SellToWebTableColumnComponent headerText="Name" dataColumn="name" sortColumn="name" filterColumn="name" />
                                            <SellToWebTableColumnComponent headerText="Logon" dataColumn="logon" sortColumn="logon" filterColumn="logon" />
                                            <SellToWebTableColumnComponent headerText="Status" dataColumn="status" sortColumn="status" filterColumn="status" className="text-center" />
                                            <SellToWebTableColumnComponent headerText="Last Updated" dataColumn="lastLogonDate" sortColumn="lastLogonDate" filterColumn="lastLogonDate" className="text-center" dataType="dateTime" />
                                        </SellToWebTableRowComponent>
                                    </SellToWebTableComponent>
                                </div>
                            </div>
                            <br />
                            <div className="card">
                                <div className="card-header">
                                    Tenant Locations
                                    <button className="btn btn-primary admin-icon" onClick={(event) => this.onAddLocationClick(event)}>
                                        Add Location
                                    </button>
                                </div>
                                <div className="card-block">
                                    <SellToWebTableComponent tableData={this.state.locations} paintTable={this.state.locationPaintTable}>
                                        <SellToWebTableRowComponent>
                                            <SellToWebTableColumnComponent headerText="Action" className="text-center admin-tenant-action-col" headerClassName="admin-tenant-action-col" dataColumnCallback={this.onLocationActionColumnCallback} />
                                            <SellToWebTableColumnComponent headerText="Name" dataColumn="name" />
                                            <SellToWebTableColumnComponent headerText="Address" dataColumn="address" dataType="anchor" href="addressLink" target="_black" />
                                        </SellToWebTableRowComponent>
                                    </SellToWebTableComponent>
                                </div>
                            </div>
                        </div>
                        <div className="card admin-flex-item">
                            <div className="card-header">
                                <SellToWebInputFileComponent id="siteArtifactFile" accept="text" onFileChange={this.onFileUpload} className="admin-tenant-site-detail-upload" />
                                <SellToWebSpinnerComponent className="admin-icon" showSpinner={this.state.isLoadingData} />
                            </div>
                            <div className="card">
                                <SellToWebTableComponent tableData={this.state.siteArtifacts} paintTable={this.state.paintTable}>
                                    <SellToWebTableRowComponent>
                                        <SellToWebTableColumnComponent headerText="Action" className="text-center admin-tenant-action-col" headerClassName="admin-tenant-action-col" dataColumnCallback={this.onActionColumnCallback} />
                                        <SellToWebTableColumnComponent headerText="Tenant Artifacts" dataColumn="name" />
                                    </SellToWebTableRowComponent>
                                </SellToWebTableComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>;
        </SellToWebAdminPageComponent>
    }
}